"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderTypeSpecificNonDatasourceFieldDetails = exports.FieldDetailsDialog = exports.FieldDetailsProperties = exports.FieldDetailsTypeRow = exports.FieldDetailsFieldName = exports.FieldDetailsPane = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@apollo/client/react/components");
const catalog_messages_1 = require("@tableau/catalog-messages");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const data_structures_1 = require("@tableau/data-structures");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const SvgFieldIcon_1 = require("../field/components/SvgFieldIcon");
const FieldFunctions_1 = require("../field/functions/FieldFunctions");
const FieldNameMapping_1 = require("../field/functions/FieldNameMapping");
const LabelsHookHelper_1 = require("../Labels/LabelsHookHelper");
const renderQueryResult_1 = require("../renderQueryResult");
const ColumnAndFieldDetailsStyles_1 = require("../style/ColumnAndFieldDetailsStyles");
const FieldInlineDescriptionEditor_1 = require("./FieldInlineDescriptionEditor");
const FieldPropertyComponents_1 = require("./FieldPropertyComponents");
const dialogWidth = 500;
exports.FieldDetailsPane = (0, vizportalclient_common_components_1.divWithStyle)('FieldDetailsPane', Object.assign(Object.assign({}, data_catalog_shared_1.vizPortalFontStyle), { fontSize: widgets_1.TabStyles.Typography.Sizing.Default }));
exports.FieldDetailsFieldName = (0, vizportalclient_common_components_1.divWithStyle)('FieldDetailsFieldName', {
    fontSize: widgets_1.TabStyles.Typography.Sizing.XLarge,
});
exports.FieldDetailsTypeRow = (0, vizportalclient_common_components_1.divWithStyle)('FieldDetailsTypeRow', {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: widgets_1.TabStyles.Spacing.DefaultSpace,
});
exports.FieldDetailsProperties = (0, vizportalclient_common_components_1.divWithStyle)('FieldDetailsProperties', {
    display: 'table',
    paddingTop: widgets_1.TabStyles.Spacing.DefaultSpace,
});
function FieldDetailsDialog(props) {
    return (react_1.default.createElement(components_1.Query, { query: catalog_queries_1.FieldDetailsDocument, variables: { fieldId: props.fieldId } }, result => (react_1.default.createElement(renderQueryResult_1.RenderQueryResult, { result: result, renderers: {
            renderData: data => (react_1.default.createElement(RenderFieldDetails, { fieldId: props.fieldId, makeFieldUrl: props.makeFieldUrl, onClose: props.onClose, canEditDescription: props.canEditDescription, datasourceLuid: props.datasourceLuid, afterDescriptionChange: props.afterDescriptionChange, fields: data.fields })),
        } }))));
}
exports.FieldDetailsDialog = FieldDetailsDialog;
function RenderFieldDetails(props) {
    const field = props.fields && props.fields[0];
    if (!field) {
        return null;
    }
    const fieldIcon = (0, FieldFunctions_1.iconForField)(field);
    return (react_1.default.createElement(widgets_1.DialogWidget, { testId: 'field-details', title: catalog_messages_1.Messages.FieldDetails(), type: widgets_1.DialogType.NormalWithTitleBar, positioningBehavior: widgets_1.DialogPositioningBehavior.Centered, dialogWidth: dialogWidth, showCloseButton: true, showFooter: false, isModal: true, onCloseRequest: props.onClose, handleGlassClick: props.onClose },
        react_1.default.createElement(exports.FieldDetailsPane, null,
            react_1.default.createElement(exports.FieldDetailsFieldName, null, field.name),
            react_1.default.createElement(exports.FieldDetailsTypeRow, null,
                react_1.default.createElement(SvgFieldIcon_1.SvgFieldIcon, { fieldIcon: fieldIcon }),
                fieldIcon ? FieldNameMapping_1.FieldNameMappings[fieldIcon]() : null),
            react_1.default.createElement(LabelsHookHelper_1.LabelWrapper, { itemInfo: field, isEager: true, kind: 'chip', wrapper: (e) => react_1.default.createElement("span", { style: ColumnAndFieldDetailsStyles_1.columnAndFieldDetailsLabelsStyle }, e) }),
            react_1.default.createElement(exports.FieldDetailsProperties, null,
                RenderDescriptions(field, props.canEditDescription, props.afterDescriptionChange, props.datasourceLuid),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyFolderName, { folderName: field.folderName }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyIsHidden, { isHidden: field.isHidden }),
                RenderTypeSpecificFieldDetails(field, props.makeFieldUrl),
                RenderRelatedItems(field)))));
}
function RenderDescriptions(field, canEditDescription, afterDescriptionChange, datasourceLuid) {
    if (field.__typename === 'DatasourceField' && field.remoteField) { // workbook field descriptions cannot currently be edited
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyDescription, { labelFunc: catalog_messages_1.Messages.DescriptionWorkbook, description: field.description }),
            react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyDescription, { labelFunc: catalog_messages_1.Messages.DescriptionDataSource, description: field.remoteField.description })));
    }
    else {
        return (react_1.default.createElement(FieldInlineDescriptionEditor_1.FieldInlineDescriptionEditor, { canEditDescription: canEditDescription, description: field.description || '', datasourceLuid: datasourceLuid || '', fullyQualifiedFieldName: field.fullyQualifiedName || '', fieldType: field.__typename, afterDescriptionChange: afterDescriptionChange }));
    }
}
function RenderTypeSpecificFieldDetails(field, makeFieldUrl) {
    if (field.__typename !== 'DatasourceField') {
        return RenderTypeSpecificNonDatasourceFieldDetails(field, makeFieldUrl);
    }
    else if (field.remoteField) {
        return RenderTypeSpecificNonDatasourceFieldDetails(field.remoteField, makeFieldUrl);
    }
    else {
        return null;
    }
}
function RenderRelatedItems(field) {
    if (field.__typename === 'ColumnField') {
        const count = field.columnsConnection ? field.columnsConnection.totalCount : null;
        return react_1.default.createElement(FieldPropertyComponents_1.ColumnsReferencingField, { fieldId: field.id, rowCount: count });
    }
    else if (field.__typename === 'DatasourceField') {
        const remoteField = field.remoteField;
        if (remoteField) {
            const datasource = remoteField.datasource;
            const datasourceVizPortalUrlId = datasource && datasource.__typename === 'PublishedDatasource'
                ? datasource.vizportalUrlId
                : null;
            const datasourceName = datasource ? datasource.name : null;
            return (react_1.default.createElement(FieldPropertyComponents_1.ConnectedField, { fieldId: remoteField.id, fieldName: remoteField.name, datasourceVizPortalUrlId: datasourceVizPortalUrlId, datasourceName: datasourceName }));
        }
        else {
            return null;
        }
    }
    else {
        const count = field.fieldsConnection ? field.fieldsConnection.totalCount : null;
        return react_1.default.createElement(FieldPropertyComponents_1.FieldsReferencedByField, { fieldId: field.id, rowCount: count });
    }
}
function RenderTypeSpecificNonDatasourceFieldDetails(field, makeFieldUrl) {
    switch (field.__typename) {
        case 'BinField':
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyDataCategory, { dataCategory: field.dataCategory }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyDataType, { dataType: field.dataType }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyRole, { role: field.role }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyFormula, { formula: field.formula, fields: field.fields, parameters: field.parameters, makeFieldUrl: makeFieldUrl }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyBinSize, { binSize: field.binSize })));
        case 'CalculatedField':
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyDataCategory, { dataCategory: field.dataCategory }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyDataType, { dataType: field.dataType }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyRole, { role: field.role }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyAggregation, { aggregation: field.aggregation }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyAggregationParam, { aggregationParam: field.aggregationParam }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyDefaultFormat, { defaultFormat: field.defaultFormat }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertySemanticRole, { semanticRole: field.semanticRole }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyFormula, { formula: field.formula, fields: field.fields, parameters: field.parameters, makeFieldUrl: makeFieldUrl }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyHasUserReference, { hasUserReference: field.hasUserReference }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyIsAutoGenerated, { isAutoGenerated: field.isAutoGenerated })));
        case 'ColumnField':
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyDataCategory, { dataCategory: field.dataCategory }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyDataType, { dataType: field.dataType }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyRole, { role: field.role }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyAggregation, { aggregation: field.aggregation }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyAggregationParam, { aggregationParam: field.aggregationParam }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyDefaultFormat, { defaultFormat: field.defaultFormat }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertySemanticRole, { semanticRole: field.semanticRole })));
        case 'CombinedField':
            return null;
        case 'CombinedSetField':
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyCombinationType, { combinationType: field.combinationType }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyDelimiter, { delimiter: field.delimiter })));
        // We don't expect datasource fields here;
        // they're handled in renderTypeSpecificFieldDetails.
        case 'DatasourceField':
            return null;
        case 'GroupField':
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyDataCategory, { dataCategory: field.dataCategory }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyDataType, { dataType: field.dataType }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyRole, { role: field.role }),
                react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyHasOther, { hasOther: field.hasOther })));
        case 'HierarchyField':
            return null;
        case 'SetField':
            return null;
        default:
            (0, data_structures_1.assertNever)(field);
            return null;
    }
}
exports.RenderTypeSpecificNonDatasourceFieldDetails = RenderTypeSpecificNonDatasourceFieldDetails;
//# sourceMappingURL=FieldDetailsDialog.js.map